import {
  LOAD_FIRESTORE_DATA,
  FIRESTORE_ERROR,
  LOAD_FIRESTORE_DOC,
  LOADING_DOC,
  DOC_LOADED,
  LOADING_COLLECTION,
  COLLECTION_LOADED,
} from '../store/actions/firestore';

import { notifyUser } from './_helpers.js';

export class Collections {
  constructor(collection) {
    this.collection = collection;
  }

  queryDatabase(firestore, dispatch) {
    dispatch({ type: LOADING_COLLECTION });
    return firestore.collection(this.collection).onSnapshot(
      (snapshot) => {
        const data = {
          [this.collection]: {},
        };
        const ordered = {
          [this.collection]: [],
        };

        if (!snapshot.empty) {
          snapshot.docs.forEach((doc) => {
            data[this.collection] = {
              ...data[this.collection],
              [doc.id]: doc.data(),
            };

            ordered[this.collection] = [
              ...ordered[this.collection],
              {
                id: doc.id,
                ...doc.data(),
              },
            ];
          });

          const payload = {
            data: { ...data },
            ordered: { ...ordered },
          };
          dispatch({
            type: LOAD_FIRESTORE_DATA,
            payload,
          });
          dispatch({ type: COLLECTION_LOADED });
        } else {
          const payload = {
            data,
            ordered,
          };
          dispatch({
            type: LOAD_FIRESTORE_DATA,
            payload,
          });
          dispatch({ type: COLLECTION_LOADED });
        }
      },
      (error) => {
        dispatch({
          type: FIRESTORE_ERROR,
          payload: {
            type: 'Firestore data',
            error,
          },
        });
        dispatch({ type: COLLECTION_LOADED });
      }
    );
  }
}

export class Doc {
  constructor(collection, doc) {
    this.collection = collection;
    this.doc = doc || 'k';
  }

  queryDatabase(firestore, dispatch) {
    dispatch({ type: LOADING_DOC });
    return firestore
      .collection(this.collection)
      .doc(this.doc)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [this.collection]: {
                  [doc.id]: doc.data(),
                },
              },
            });
            dispatch({ type: DOC_LOADED });
          } else {
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [this.collection]: null,
              },
            });
            dispatch({ type: DOC_LOADED });
          }
        },
        (error) => {
          dispatch({ type: FIRESTORE_ERROR, payload: { type: 'Doc', error } });
          dispatch({ type: DOC_LOADED });
        }
      );
  }
}

export class DocArray {
  constructor(collection, doc, filter, p) {
    this.collection = collection;
    this.doc =
      collection === 'notification' ? doc.split(',') : !doc ? ['k'] : [doc];
    this.filter = filter;
    this.p = p;
  }
  queryDatabase(firestore, dispatch) {
    dispatch({ type: LOADING_DOC });
    return firestore
      .collection(this.collection)
      .where(this.filter, 'in', this.doc)
      .onSnapshot(
        (querySnapshot) => {
          if (!querySnapshot.empty) {
            let docArray = [];
            querySnapshot.forEach((doc) => {
              if (this.collection === 'notification') {
                const checks = {
                  merchants: 'merchant',
                  delivery: 'deliveryServices',
                  partners: 'partner',
                };

                if (Array.isArray(doc.data().type)) {
                  doc.data().type.forEach((v) => {
                    if (this.p?.[checks[v]]) {
                      docArray.push({
                        id: doc.id,
                        ...doc.data(),
                      });
                    }
                  });
                } else {
                  if (
                    doc.data().type === 'merchants' ||
                    doc.data().type === 'delivery' ||
                    doc.data().type === 'partners'
                  ) {
                    if (this.p?.[checks[doc.data().type]]) {
                      docArray.push({
                        id: doc.id,
                        ...doc.data(),
                      });
                    }
                  } else {
                    docArray.push({
                      id: doc.id,
                      ...doc.data(),
                    });
                  }
                }
              } else {
                docArray.push({
                  id: doc.id,
                  ...doc.data(),
                });
              }
            });
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [this.collection]: docArray,
              },
            });

            dispatch({ type: DOC_LOADED });
          } else {
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [this.collection]: [],
              },
            });

            dispatch({ type: DOC_LOADED });
          }
        },
        (error) => {
          dispatch({ type: FIRESTORE_ERROR, payload: { type: 'Doc', error } });
          dispatch({ type: DOC_LOADED });
        }
      );
  }
}

export class AssignedVendorsArray {
  constructor(collection, doc, filter) {
    this.collection = collection;
    this.doc =
      collection === 'notification' ? doc.split(',') : !doc ? ['k'] : [doc];
    this.filter = filter;
  }
  queryDatabase(firestore, dispatch) {
    dispatch({ type: LOADING_DOC });
    return firestore
      .collection(this.collection)
      .where(this.filter, 'in', this.doc)
      .onSnapshot(
        (querySnapshot) => {
          if (!querySnapshot.empty) {
            let docArray = [];
            querySnapshot.forEach((doc) => {
              docArray.push({
                id: doc.id,
                ...doc.data(),
              });
            });
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [`${this.collection}Assigned`]: docArray,
              },
            });

            dispatch({ type: DOC_LOADED });
          } else {
            dispatch({
              type: LOAD_FIRESTORE_DOC,
              payload: {
                [`${this.collection}Assigned`]: [],
              },
            });

            dispatch({ type: DOC_LOADED });
          }
        },
        (error) => {
          dispatch({
            type: FIRESTORE_ERROR,
            payload: { type: 'Assigned vendors', error },
          });
          dispatch({ type: DOC_LOADED });
        }
      );
  }
}

export class FilterByText {
  constructor(db) {
    this.db = db;
  }

  filter(prevState) {
    if (prevState.filterBy.dbName === 'vendors') {
      return this.db
        .filter((item) =>
          item.businessProfile[prevState.filterBy.property]
            .toLowerCase()
            .includes(prevState.filterBy.value.toLowerCase())
        )
        .sort((a, b) =>
          a.businessProfile[prevState.filterBy.property].localeCompare(
            b.businessProfile[prevState.filterBy.property]
          )
        );
    } else {
      return this.db
        .filter((item) => {
          if (
            item[prevState.filterBy.property] &&
            item[prevState.filterBy.property]
              .toLowerCase()
              .includes(prevState.filterBy.value.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        })
        .sort((a, b) =>
          a[prevState.filterBy.property].localeCompare(
            b[prevState.filterBy.property]
          )
        );
    }
  }
}

export class FilterByNumber {
  constructor(db) {
    this.db = db;
  }

  filter(prevState) {
    if (prevState.filterBy.value.trim() !== '') {
      switch (prevState.filterBy.property) {
        case 'accountNumber':
          return this.db.filter(
            (item) =>
              item.bankDetails[0] &&
              item.bankDetails[0][prevState.filterBy.property] &&
              item.bankDetails[0][prevState.filterBy.property].includes(
                prevState.filterBy.value
              )
          );
        case 'totalNumberOfTransactions':
          return this.db.filter(
            (item) =>
              prevState.transactions.filter(
                ({ walletId }) => walletId === item.id
              ).length === +prevState.filterBy.value
          );
        default:
          return this.db.filter(
            (item) =>
              item[prevState.filterBy.property] &&
              item[prevState.filterBy.property]
                .toString()
                .includes(prevState.filterBy.value)
          );
      }
    } else {
      return this.db;
    }
  }
}

export class FilterBySelect {
  constructor(db) {
    this.db = db;
  }

  filter(prevState) {
    if (prevState.filterBy.value !== 'All') {
      if (prevState.filterBy.dbName === 'vendors') {
        if (prevState.filterBy.property === 'accountStatus') {
          return this.db.filter(
            (item) =>
              item[prevState.filterBy.property] === prevState.filterBy.value
          );
        } else if (prevState.filterBy.property === 'type') {
          return this.db.filter((item) =>
            item.businessProfile.hasOwnProperty(prevState.filterBy.value)
          );
        } else if (prevState.filterBy.property === 'category') {
          return this.db.filter((item) => {
            let property = item.businessProfile.partnerType
              ? 'partnerType'
              : prevState.filterBy.property;
            return item.businessProfile[property] === prevState.filterBy.value;
          });
        } else {
          return this.db.filter(
            (item) =>
              item.businessProfile[prevState.filterBy.property] ===
              prevState.filterBy.value
          );
        }
      } else {
        if (
          prevState.filterBy.dbName === 'transactions' &&
          prevState.filterBy.property === 'by' &&
          prevState.filterBy.value === 'Direct'
        ) {
          return this.db.filter((item) => item.type === 'Withdrawn');
        }

        if (
          prevState.filterBy.dbName === 'transactions' &&
          prevState.filterBy.property === 'type' &&
          prevState.filterBy.value === 'Outbound'
        ) {
          return this.db.filter(
            (item) => item.type === 'Received' && item.by !== 'Easychaw'
          );
        }

        if (
          prevState.filterBy.dbName === 'transactions' &&
          prevState.filterBy.property === 'type' &&
          prevState.filterBy.value === 'Received'
        ) {
          return this.db.filter(
            (item) => item.type === 'Received' && item.by === 'Easychaw'
          );
        }

        if (
          prevState.filterBy.dbName === 'wallets' &&
          prevState.filterBy.property === 'type' &&
          prevState.filterBy.value === 'bonuses'
        ) {
          return this.db.filter((item) => {
            if (item.hasOwnProperty('bonuses')) {
              return true;
            } else {
              return false;
            }
          });
        }

        if (
          prevState.filterBy.dbName === 'wallets' &&
          prevState.filterBy.property === 'type' &&
          prevState.filterBy.value === 'business'
        ) {
          return this.db.filter((item) => {
            if (!item.hasOwnProperty('bonuses')) {
              return true;
            } else {
              return false;
            }
          });
        }

        return this.db.filter(
          (item) =>
            item[prevState.filterBy.property] === prevState.filterBy.value
        );
      }
    } else {
      return this.db;
    }
  }
}
